import { render, staticRenderFns } from "./toubu.vue?vue&type=template&id=65788771&scoped=true"
import script from "./toubu.vue?vue&type=script&lang=js"
export * from "./toubu.vue?vue&type=script&lang=js"
import style0 from "./toubu.vue?vue&type=style&index=0&id=65788771&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65788771",
  null
  
)

export default component.exports